import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MultiTenant from "../MultiTenant";

export const NavbarLeft = ({ NavbarLogo, menu }) => {
    const [expandedItems, setExpandedItems] = useState({});
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    const handleToggle = (index) => {
        setExpandedItems((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <>
            {/* Hamburger Menu Button - Visible on Mobile Only */}
            {!isMobileMenuOpen && (
                <button
                    className="fixed top-4 left-4 z-50 lg:hidden p-2 rounded-md bg-oss-grey shadow-lg"
                    onClick={toggleMobileMenu}
                    aria-label="Toggle Menu"
                >
                    <svg
                        className="w-6 h-6 text-black"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 6h16M4 12h16m-7 6h7"
                        />
                    </svg>
                </button>
            )}

            {/* Sidebar and Overlay Container */}
            <div
                className={`fixed inset-0 ${
                    isMobileMenuOpen ? "z-40" : ""
                } lg:static lg:z-auto`}
            >
                {/* Overlay - Visible when Mobile Menu is Open */}
                {isMobileMenuOpen && (
                    <div
                        className="fixed inset-0 bg-black opacity-50 lg:hidden"
                        onClick={toggleMobileMenu}
                        aria-hidden="true"
                    ></div>
                )}

                {/* Sidebar - Visible on Large Screens and Mobile when Open */}
                <header
                    className={`
                        fixed top-0 left-0 h-full bg-oss-grey flex flex-col border-r-2 shadow-right-lg
                        transform transition-transform duration-300 ease-in-out
                        ${
                            isMobileMenuOpen
                                ? "translate-x-0 z-35 bg-white"
                                : "-translate-x-full lg:translate-x-0"
                        }
                        w-64 lg:w-[300px]
                        lg:static lg:transform-none
                        overflow-y-auto
                    `}
                >
                    <div className="flex flex-col items-start w-full h-full">
                        <div className="h-[100px] border-b w-full flex items-center px-4">
                            <img
                                className="max-w-[200px] mb-4"
                                src={NavbarLogo}
                                alt="Navbar Logo"
                            />
                            {/* Close Button for Mobile */}
                            {/* <button
                                className="ml-auto lg:hidden"
                                onClick={toggleMobileMenu}
                                aria-label="Close Menu"
                            >
                                <svg
                                    className="w-6 h-6 text-black"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button> */}
                        </div>
                        <MultiTenant />
                        <ul className="flex flex-col text-black items-start transition-all duration-300 w-full flex-1">
                            {menu &&
                                menu.options.map((option, index) => (
                                    <li
                                        key={index}
                                        className={`p-4 border-b w-full ${
                                            location.pathname.includes(option.url)
                                                ? "font-semibold"
                                                : "opacity-50"
                                        }`}
                                    >
                                        {option.children ? (
                                            <div>
                                                <button
                                                    className="hover:underline w-full text-left flex items-center"
                                                    onClick={() => handleToggle(index)}
                                                >
                                                    {/* Icon */}
                                                    {option.icon && (
                                                        <span className="mr-3 flex-shrink-0">
                                                            {option.icon}
                                                        </span>
                                                    )}
                                                    <span className="flex-1">{option.name}</span>
                                                    <svg
                                                        className={`w-4 h-4 transform transition-transform ${
                                                            expandedItems[index]
                                                                ? "rotate-90"
                                                                : "rotate-0"
                                                        }`}
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="2"
                                                            d="M9 5l7 7-7 7"
                                                        />
                                                    </svg>
                                                </button>
                                                <ul
                                                    className={`ml-6 mt-2 ${
                                                        expandedItems[index]
                                                            ? "block"
                                                            : "hidden"
                                                    }`}
                                                >
                                                    {option.children.map(
                                                        (child, childIndex) => (
                                                            <li
                                                                key={childIndex}
                                                                className="p-2 border-b border-oss-darkgrey w-full"
                                                            >
                                                                <Link
                                                                    to={child.url}
                                                                    className="flex items-center space-x-2 block w-full truncate hover:underline"
                                                                    onClick={() =>
                                                                        setIsMobileMenuOpen(false)
                                                                    }
                                                                >
                                                                    {/* Optionally, add icons for child items */}
                                                                    {child.icon && (
                                                                        <span className="flex-shrink-0">
                                                                            {child.icon}
                                                                        </span>
                                                                    )}
                                                                    <span>{child.name}</span>
                                                                </Link>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </div>
                                        ) : (
                                            <Link
                                                to={option.url}
                                                className="flex items-center space-x-2 block w-full truncate hover:underline"
                                                onClick={() =>
                                                    setIsMobileMenuOpen(false)
                                                }
                                            >
                                                {/* Icon */}
                                                {option.icon && (
                                                    <span className="mr-3 flex-shrink-0">
                                                        {option.icon}
                                                    </span>
                                                )}
                                                <span>{option.name}</span>
                                            </Link>
                                        )}
                                    </li>
                                ))}
                        </ul>
                    </div>
                </header>
            </div>
        </>
    );
};
